import { Injectable } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  AddSqaErrorMessages,
  AddSqaFormAttributes,
  AddSqaPageContent,
  ErrorMessage,
  Errors,
  SecurityQuestionContentApi
} from '@com-delta-idp/mnx-login-ui';
import {
  security_answer_one_check,
  security_answer_two_check,
  security_question_one_check,
  security_question_two_check
} from '../../../validator/add-sqa-validator.service';
import { LoginModalContent } from '../../models/aem';
import { AddSqaErrorMessageHelperService } from './add-sqa-error-message-helper.service';

@Injectable({
  providedIn: 'root'
})
export class AddSqaHelperService {
  addSqaForm!: UntypedFormGroup;

  constructor(
    private addSqaErrorMessageHelper: AddSqaErrorMessageHelperService
  ) {}

  createForm(): UntypedFormGroup {
    this.addSqaForm = new UntypedFormGroup({
      answerOne: new UntypedFormControl(null, [
        Validators.required,
        security_answer_one_check
      ]),
      answerTwo: new UntypedFormControl(null, [
        Validators.required,
        security_answer_two_check
      ]),
      questionOne: new UntypedFormControl(null, [
        Validators.required,
        security_question_one_check
      ]),
      questionTwo: new UntypedFormControl(null, [
        Validators.required,
        security_question_two_check
      ])
    });
    return this.addSqaForm;
  }

  getPageContent(
    aemResponse: LoginModalContent,
    securityQuestions: SecurityQuestionContentApi
  ): AddSqaPageContent {
    const { addSecurityQuestionAnswers, pageHeader } = aemResponse;
    let securityQuestionList = [];
    securityQuestionList = securityQuestions.securityQuestionList.map(
      (securityQuestion) => {
        return {
          type: securityQuestion.currentIndicator,
          value: securityQuestion.questionNumber,
          label: securityQuestion.questionText
        };
      }
    );
    return {
      ...addSecurityQuestionAnswers,
      securityQuestionList: securityQuestionList,
      pageHeader: {
        ...pageHeader,
        headerTitle: addSecurityQuestionAnswers.headerTitle,
        headerSubTitle: addSecurityQuestionAnswers.headerSubTitle,
        contentBodyHeader: addSecurityQuestionAnswers.contentBodyHeader
      },
      buttonLabel: addSecurityQuestionAnswers.nextDisplayView.button_modal,
      errors: this.getInitialErrorMessage(aemResponse.errors)
    };
  }

  getInitialErrorMessage(errors: Errors): AddSqaErrorMessages {
    const errorMessages: AddSqaErrorMessages = {
      answerOneErrorMessage: {
        INVALID_FIRST_SEC_ANS: '',
        ANS_IN_USE: '',
        SEC_ANS_LESS_THAN_FOUR_CHAR: ''
      },
      answerTwoErrorMessage: {
        INVALID_SECOND_SEC_ANS: '',
        ANS_IN_USE: '',
        SEC_ANS_LESS_THAN_FOUR_CHAR: ''
      },
      questionOneErrorMessage: {
        SEL_FIRST_SEC_QUESTION: ''
      },
      questionTwoErrorMessage: {
        SEL_SECOND_SEC_QUESTION: '',
        QUESTION_IN_USE: ''
      },
      alertWarning: ''
    };
    errors.errorMessages.forEach((option: ErrorMessage) => {
      this.addSqaErrorMessageHelper.initialErrorMessage(option, errorMessages);
    });
    errorMessages.alertWarning = 'To continue, please correct the';
    return errorMessages;
  }

  getFormAttributes(): AddSqaFormAttributes {
    return {
      errorCount: 0,
      submitAttempt: false,
      errorAlertBanner: false,
      questionOneControlTouched: false,
      answerOneControlTouched: false,
      questionTwoControlTouched: false,
      answerTwoControlTouched: false,
      disableActionButton: false
    };
  }
}
